import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        token: '='
    },
    template: `
<div class="col00">
            <div class="colholder center-col equalize">
                <div class="col col01">
                    <form role="form" ng-submit="vm.save()" class="well color01">
                        <alert-error ng-if="vm.form.errors.activationToken">{{ vm.form.errors.activationToken }}</alert-error>
                        <div class="form">
                            <alert-error ng-if="vm.form.invalid">{{ 'general.There were errors processing the form' | translate }}</alert-error>
                            <form-row error="vm.form.errors.password">
                                <label class="label">{{ 'auth.New password' | translate }}</label>
                                <div class="items">
                                    <input type="password" class="form-control" ng-model="vm.form.model.password">
                                    <form-row-error></form-row-error>
                                </div>
                            </form-row>
                            <form-row error="vm.form.errors.repeatPassword">
                                <label class="label">{{ 'auth.Repeat password' | translate }}</label>
                                <div class="items">
                                    <input type="password" class="form-control" ng-model="vm.form.model.repeatPassword">
                                    <form-row-error></form-row-error>
                                </div>
                            </form-row>
                        </div>
                        <ul class="actions01 mobile-stretch">
                            <li class="f-right"><input type="submit" value="{{ 'auth.Continue' | translate }}" class="btn main"></li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $state, $stateParams, toastr, FormFactory, UserResource) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.toastr = toastr;
        const defaultModel = {
            activationToken: this.token,
            password: '',
            repeatPassword: ''
        };
        this.form = FormFactory.create(defaultModel, model => UserResource.updatePassword(model).$promise);
    }

    save () {
        this.form
            .save()
            .then(() => {
                this.toastr.success(this.$translate.instant('auth.Password changed, please log in with new password.'));
                this.$state.go('unauthorized.login', { company: this.$stateParams.company });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/auth/confirm/index.js